export * from './super-smart.component';
